import React from 'react';
import c from 'classnames';

import type { SwirlIllustrationsProps } from '..';

import './style.scss';

export type SwirlIllustrationsParagraphProps = Pick<SwirlIllustrationsProps, 'colorVariant'>;

const SwirlIllustrationsParagraph: React.FC<SwirlIllustrationsParagraphProps> = ({
  colorVariant,
}) => {
  const classNames = c('SwirlIllustrations--CTA', {
    [`SwirlIllustrations--CTA--variant--${colorVariant as string}`]: colorVariant,
  });

  return (
    <div className={classNames} />
  );
};

export default SwirlIllustrationsParagraph;
